import { useLazyGetContractsQuery } from '@/api/queries/contract';
import { useAppSelector } from '@/redux/store';

const useGetContracts = (): (() => void) => {
  const [getContracts] = useLazyGetContractsQuery();
  const minLevelForContracts = useAppSelector(
    (state) => state.user.user?.settings.minUserLevelForContracts,
  );
  const userLevel = useAppSelector((state) => state.user.user?.level);

  const triggerGetContracts = (): void => {
    if (userLevel !== undefined && minLevelForContracts !== undefined) {
      if (userLevel >= minLevelForContracts) {
        getContracts();
      }
    }
  };

  return triggerGetContracts;
};

export { useGetContracts };
